import type { MarkdownIt } from 'markdown-it';

/** 兼容旧 AI 答复中的全角竖线表格；仅转换完整、列数一致的独立段落。 */
export function legacyPipeTables(markdown: MarkdownIt): void {
  markdown.core.ruler.before('inline', 'legacy_pipe_tables', (state) => {
    if (!state.env?.legacyTables) return;
    for (let index = 0; index < state.tokens.length - 2; index += 1) {
      const open = state.tokens[index]!;
      const body = state.tokens[index + 1]!;
      const close = state.tokens[index + 2]!;
      // 在 Markdown 分块后处理，代码块、行内代码和标准表格都保留原样。
      if (open.type !== 'paragraph_open' || body.type !== 'inline' || close.type !== 'paragraph_close') continue;
      const lines = body.content.split('\n');
      if (lines.length < 3 || lines.some((line) => !line.includes('｜') || line.includes('`'))) continue;
      const rows = lines.map((line) => line.trim().replace(/^｜|｜$/g, '').split('｜').map((cell) => cell.trim()));
      const columns = rows[0]!.length;
      if (columns < 3 || rows.some((row) => row.length !== columns || row.some((cell) => cell === ''))) continue;

      const table: typeof state.tokens = [];
      let level = open.level;
      const push = (type: string, tag: string, nesting: -1 | 0 | 1, content = '') => {
        const token = new state.Token(type, tag, nesting);
        if (nesting === -1) level -= 1;
        token.level = level;
        token.block = true;
        if (nesting === 1) level += 1;
        if (type === 'inline') {
          token.content = content;
          token.children = [];
        }
        table.push(token);
      };
      push('table_open', 'table', 1);
      for (const [rowIndex, row] of rows.entries()) {
        const section = rowIndex === 0 ? 'thead' : 'tbody';
        if (rowIndex <= 1) push(`${section}_open`, section, 1);
        push('tr_open', 'tr', 1);
        for (const cell of row) {
          const tag = rowIndex === 0 ? 'th' : 'td';
          push(`${tag}_open`, tag, 1);
          push('inline', '', 0, cell);
          push(`${tag}_close`, tag, -1);
        }
        push('tr_close', 'tr', -1);
        if (rowIndex === 0 || rowIndex === rows.length - 1) push(`${section}_close`, section, -1);
      }
      push('table_close', 'table', -1);
      // 只替换渲染 token，消息原文和服务端历史不变；单元格继续走既有安全 Markdown 解析。
      state.tokens.splice(index, 3, ...table);
      index += table.length - 1;
    }
  });
}
